import { User } from '../models/user'
import { IdentityConfig } from '../configs/identity.config'
import { QueryErrorCode, QueryResponse } from 'shared-services'
import { UserDto } from '../models/user.dto'
import { userMapper } from '../mappers/user-mapper'

export interface UserGetterService {
  getUser(): Promise<User>
}

export class UserGetterServiceImpl {
  public constructor(private readonly identityConfig: IdentityConfig) {}

  public async getUser(): Promise<User> {
    const response = await fetch(`${this.identityConfig.apiBaseUrl}/v1/user`, {
      credentials: 'include',
    })

    if (!response.ok) {
      return User.asNotSignedIn()
    }

    const queryResponse = (await response.json()) as QueryResponse<
      UserDto,
      QueryErrorCode
    >

    if (queryResponse.isSuccessful) {
      return userMapper.mapToSignedInUser(queryResponse.result)
    }

    return User.asNotSignedIn()
  }
}
